import React, { useState, useEffect, useRef, memo } from "react";
import { HTTP } from "../api/http-common";
import { useNavigate, Link,useParams } from "react-router-dom";
import { isValidEmail } from '../component/common';
import { CircleX, Trash, X } from "lucide-react";
import Swal from 'sweetalert2'
import { useGlobalContext } from "../component/GlobalContext";
import AdminGalleryView from "./AdminGalleryView";

function AdminGalleryEdit() {
  const { id } = useParams();
  const galleryId = Number(id);
  const navigate = useNavigate();
  const { isAuthenticated } = useGlobalContext();
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [description, setDescription] = useState('');
  const [bannerImage, setBannerImage] = useState(null); // State for the banner image
  const [filePath, setFilePath] = useState(null); // State for the banner image
  const [preview, setPreview] = useState(null); // State for image preview
  const [descriptionError, setDescriptionError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [title, setTitle] = useState("");
  const [statusError, setStatusError] = useState("");
  const [status, setStatus] = useState(true);
  const [fileError, setFileError] = useState("");
  const [galleryList, setGalleryList] = useState([]);
  const [isDragging, setIsDragging] = useState(false); // State to indicate dragging
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false); // Reset dragging state
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      handleFileChange(droppedFile); // Process the dropped file
    }
  };
  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true); // Set dragging state to true
  };

  const handleDragLeave = () => {
    setIsDragging(false); // Reset dragging state when leaving drop area
  };

  const handleFileChange = (file, event, fieldName) => {
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setPreview(reader.result); // Set preview URL for the image
      };
      if (fieldName === "file") {
        setFile(file); // Set file for the main image
      } else if (fieldName === "banner_image") {
        setBannerImage(file); // Set file for the banner image
      }
      reader.readAsDataURL(file); // Read file as Data URL for image preview
      setFile(file); // Set file for the main image
    }
  };

  const handleInputChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      handleFileChange(selectedFile); // Process the selected file
    }
  };

  const handleCancelUpload = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        setFile(null);
        setPreview(null);
        Swal.fire("Removed!", "Your image has been removed.", "success");
      }
    });
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    loadGalleryData();
  }, []);

  const loadGalleryData = async () => {
    const access_token = localStorage.getItem('access_token');
    const config = {
      headers: { 'Content-Type': 'application/json', 'token': access_token },
    };
    
    HTTP.get(`/user/media_gallery/${galleryId}`, config)
      .then((response) => {
        const data = response.data;
        if (response.status === 200) {
          setTitle(data.title)
          setStatus(data.status)
          setDescription(data.description)
          setFilePath(data.path)
        }
        console.log("data for image", data);
      })
      .catch((error) => {
        // console.log(error);
        if (error.response && error.response.status === 401) {
          // Handle unauthorized error
          // localStorage.clear();
          // navigate('/'); // Redirect to login page
        }

      });
  }

  const toggleStatus = async (id, currentStatus) => {
    // Check if couponCode is valid
    if (!id) {
      console.error("Media is undefined.");
      return;
    }

    // Use SweetAlert for confirmation
    const isConfirmed = await Swal.fire({
      title: "Are you sure?",
      text: "You are about to update the Media status.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    });

    if (!isConfirmed.isConfirmed) return;

    try {
      const response = await HTTP.put(
        `/user/${id}/toggle_status` // Use couponCode in the URL
      );
      console.log("Response Data:", response.data); // Debugging
      setGalleryList((prevMedia) =>
        prevMedia.map((media_gallery) =>
          media_gallery.id === id ? { ...media_gallery, status: response.data.status } : media_gallery
        )
      );
      // Show a success alert after updating the status
      Swal.fire("Updated!", "The media status has been updated.", "success");
      // fetchMedia();
    } catch (error) {
      console.error("Error:", error); // Debugging
      setError("Error updating media status.");
      // Show an error alert in case of failure
      Swal.fire("Error", "There was an error updating the media status.", "error");
    }
  };

  const resetValidationErrors = () => {
    // For Address
    setTitleError('');
    setDescriptionError('');
    setFileError('');
    setStatusError('');
  };
  const resetForm = () => {
    resetValidationErrors()
    setFile('');
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // This will reset the input
    }
    setDescription('');
    setTitle('');
    setStatus('');
  };
  const validateField = () => {
    resetValidationErrors();

    let checked = true;


    //For Address 

    if (title === '') {
      setTitleError('Please enter title');
      if (checked) {
        checked = false;
      }
    } else if (title.length < 5) {
      setTitleError("Please enter minimum 5 characters");
      if (checked) {
        checked = false;
      }
    } else if (title.length > 200) {
      setTitleError("Max character limit is 200");
      if (checked) {
        checked = false;
      }
    }

    if (description === '') {
      setDescriptionError('Please enter description');
      if (checked) {
        checked = false;
      }
    } else if (description.length < 5) {
      setDescriptionError("Please enter minimum 5 characters");
      if (checked) {
        checked = false;
      }
    } else {
      setDescriptionError(""); // Clear error if validation passes
    }

    // Check file size (5MB limit)
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    // Check file type (only images allowed)
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
    if (file && file.size > maxSize) {
      setFileError("File size exceeds 5MB.");
      if (checked) {
        checked = false;
      }
    } else if (file && !allowedTypes.includes(file.type)) {
      setFileError("Only image files (JPG, PNG, GIF) are allowed.");
      if (checked) {
        checked = false;
      }
    }

    return checked;
  };
  const handleDeleteLogoImage = async (e) => {
      e.preventDefault();
      try {
        const access_token = localStorage.getItem("access_token");
        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
            token: access_token,
          },
        };
  
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "This action cannot be undone!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel",
        });
        if (result.isConfirmed) {
          const response = await HTTP.delete(`/user/media_gallery/delete-img/${galleryId}`, config);
          if (response.data.status === '200') {
            loadGalleryData();
          }
        }
  
  
      } catch (error) {
        console.error('Error deleting banner image:', error);
        // Handle error (e.g., show an alert or a message to the user)
      }
    };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateField()) {
      try {
        const access_token = localStorage.getItem('access_token');
        let config = {
          headers: { "Content-Type": "multipart/form-data", token: access_token },
        };
        const formData = new FormData();
        formData.append("title", title);
        formData.append("description", description);
        formData.append("status", status ? "true" : "false");
        // formData.append("file", file);
        // formData.append("banner_image", bannerImage);
        if (file) {
          formData.append("file", file);  // ✅ Only append if `file` exists
        }

        await HTTP.post(
          `/user/media_gallery/update/${galleryId}`,
          formData,
          config
        )
          .then(async (response) => {
            if (response.status === 200) {
              Swal.fire({
                title: 'Gallery updated successfully!',
                //   text: "Please verify your email before login",
                icon: "success"
              });
              loadGalleryData();
              setPreview(null);
              // navigate('/media-gallery');
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              resetValidationErrors();
              //   setPasswordError(error.response.data.detail);
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 400) {
              Swal.fire({
                title: 'Error!',
                text: 'You are already registered!',
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 422) {
              console.log(error.response)
              // alert('here')
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail[0].msg + " " + error.response.data.detail[0].input,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
          });
      } catch (error) {

      }
    }
  };

  const handleDelete = async (id) => {
    const access_token = localStorage.getItem("access_token");
    const config = {
      headers: { "Content-Type": "application/json", token: access_token },
    };
    try {
      const access_token = localStorage.getItem('access_token');
      let config = {
        headers: { "Content-Type": "application/json", token: access_token },
      };

      // Show confirmation dialog
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (result.isConfirmed) {
        await HTTP.delete(
          `user/gallery/delete/${id}`,
          config
        )
          .then(async (response) => {
            if (response.status === 200) {
              Swal.fire({
                title: response.data.message,
                //   text: "Please verify your email before login",
                icon: "success"
              });
                navigate('/media-gallery');
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              resetValidationErrors();
              //   setPasswordError(error.response.data.detail);
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 400) {
              Swal.fire({
                title: 'Error!',
                text: 'You are already registered!',
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 422) {
              console.log(error.response)
              // alert('here')
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail[0].msg + " " + error.response.data.detail[0].input,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
          });
        // setIsLoading(false);
      }
    } catch (error) {
    }
  };

  return (
    <>
      <div className="container mx-auto pt-8">
        <div className="bg-white rounded-lg p-6 border-gray-200 border">
          <div className="flex item-center justify-between">
            <div className="w-full ">

              <div className="flexbox">

                {/* 1st section  */}
                <div className="w-1/2 px-3">
               
                  {/* Title */}
                  <div className="">
                    <label htmlFor="title" className="text-sm font-semibold">Title</label>
                    <input
                      type="text"
                      id="title"
                      name="title"
                      className="w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                    {titleError && <span className="text-sm text-red-500">{titleError}</span>}
                  </div>

                  {/* Description */}
                  <div className="py-2">
                    <label htmlFor="description" className="text-sm pb-2 inline-block font-semibold">Description</label>
                    <textarea
                      id="description"
                      name="description"
                      className="w-full p-3 rounded-lg border border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                    {descriptionError && (
                      <span className="text-sm text-red-500">{descriptionError}</span>
                    )}
                  </div>
                  {/* Status */}
                  <div className="flexbox">
                    <label htmlFor="status" className="text-sm font-semibold pr-2">Status</label>
                    <div className="relative flex items-center">
                      <input
                        id="status"
                        type="checkbox"
                        checked={status}
                        onChange={(e) => setStatus(e.target.checked)}
                        className="hidden"
                      />
                      <div
                        className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer transition-all duration-300 ${status ? "bg-green-500" : "bg-gray-300"
                          }`}
                        onClick={() => setStatus(!status)}
                      >
                        <div
                          className={`w-5 h-5 bg-white rounded-full shadow-md transform transition-all duration-300 ${status ? "translate-x-6" : "translate-x-0"
                            }`}
                        ></div>
                      </div>
                    </div>
                    {statusError && <span className="text-sm text-red-500">{statusError}</span>}
                  </div>
                </div>


                {/* 2nd section  */}
                <div className="w-1/2 px-3">
                  {/* Upload Image */}
                  <div className="">
                    <span className="flex items-center justify-between">
                      <label htmlFor="file" className="text-sm font-semibold">Upload Image</label>
                      {preview && (
                        <button
                          onClick={handleCancelUpload}
                          className="cursor-pointer text-red-500 hover:text-red-700"
                        >
                          <CircleX size={24} />
                        </button>
                      )}
                    </span>
                    <div
                      className={`border-2 ${isDragging ? "border-blue-400" : "border-gray-400"
                        } border-dashed rounded-lg p-2.5 mt-2 cursor-pointer text-center relative min-h-[140px] flexbox  justify-center`}
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onClick={handleClick}
                    >
                      <input
                        type="file"
                        id="file"
                        name="file"
                        accept="image/*"
                        className="hidden"
                        onChange={handleInputChange}
                        ref={fileInputRef}
                      />
                      {preview ? (
                        <div className="relative">
                          <img src={preview} alt="Preview" className="w-45 h-40 object-cover mx-auto rounded" />
                          <p className="mt-1.5">Click to replace the image</p>
                        </div>
                      ) : (
                        <p className="text-sm text-gray-500">Drag & drop or click to upload an image</p>
                      )}
                    </div>
                    {fileError && <span className="text-sm text-red-500">{fileError}</span>}
                    {file && !preview && (
                      <p className="text-sm text-gray-500 mt-2">
                        You can change the image by clicking on the "Cancel" icon after uploading.
                      </p>
                    )}
                  </div>
                  <br></br>
                  <div className="relative mt-2 flexbox ">
                    <div className="w-2/3">
                      
                      {filePath && (
                        <>
                            <img src={filePath} className="upload-image" alt="Cropped Banner" />
                            <button
                            className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1"
                            onClick={handleDeleteLogoImage}
                          >
                            <X />
                          </button>
                        </>
                        
                      )}
                    </div>
                  </div>
                </div>

                


              </div>
            </div>
          </div>

          {/* <div>&nbsp;</div> */}
          <div className="px-3 pt-6">
            <button
              type="submit"
              className="theme-button text-white px-4 py-2 rounded-md shadow-sm"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      <div className="container mx-auto">
        <AdminGalleryView galleryList={galleryList} handleDelete={handleDelete} toggleStatus={toggleStatus} loading={loading} />
      </div>
    </>
  )
}

export default memo(AdminGalleryEdit);